import fileObjectActions from './fileObjectActions';
import tokenActions from './tokenActions';

const allActions = {
  fileObjectActions,
  tokenActions
};

export default allActions;
